module.exports = __webpack_public_path__ + "static/2-bc6a015523a68ef628d3287b9030aa6b.png";